import { Component, Input, Output, EventEmitter, OnChanges, SimpleChange } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { OnInit } from '@angular/core';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';
import { CustomerInputService } from '../Services/customer-input.service';

@Component({
  selector: 'app-calendar-head',
  templateUrl: './calendar-head.component.html',
  styleUrls: ['./calendar-head.component.css']
})
export class CalendarHeadComponent implements OnInit {
  @Input() view: string;
  @Input() viewDate: Date;
  @Input() locale: string = 'ja';
  @Input() isEvent: boolean = false;
  @Input() isViewType: boolean = false;
  @Input() userLink: boolean = false;
  @Output() viewChange: EventEmitter<string> = new EventEmitter();
  @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();
  @Output() onDivisionChange = new EventEmitter<string>();
  @Output() onTypeChange = new EventEmitter<string>();
  @Output() viewUserSelect = new EventEmitter<boolean>();

  division_code: string = '0';
  view_type: string = 'bef';
  divisions: any;
  users: any;
  sales_users: any;
  construction_users: any;

  constructor(
    public customerInputService: CustomerInputService,
  ) { }

  init() {
  }
  ngOnInit() {
    //
    let list = this.customerInputService.customerBase(0);
    list.subscribe(list => {
      this.divisions = list['division'];
      this.users = list['users'];
      this.sales_users = list['sales_users'];
      this.construction_users = list['construction_users'];
    });
    /*
    this.divisions = [
      { division_code: '0', division_name: '全体' },
      { division_code: '1', division_name: 'ニコニコ住宅' },
      { division_code: '2', division_name: '平屋本舗' },
    ]
    */
  }
  divisionChange(division: string) {
    this.onDivisionChange.emit(division);
  }
  typeChange(type: string) {
    this.onTypeChange.emit(type);
  }
  clickUserList() {
    this.viewUserSelect.emit(true);
    return false;
  }
}
